import { BaseControl, CheckboxControl as WPCheckboxControl } from '@wordpress/components';

const CheckboxControl = ({ field, value, onChange }) => {
    const { label, help, options = [], disabled } = field;

    // Multi-checkbox mode
    if (Array.isArray(options) && options.length) {
        const selectedValues = Array.isArray(value) ? value : [value];
        return (
            <BaseControl label={label} help={help} __nextHasNoMarginBottom>
                {options.map((opt) => {
                    if (!opt.label) return null;
                    const optValue = opt.value || opt.label;
                    const isChecked = selectedValues.includes(opt.value);

                    return (
                        <WPCheckboxControl
                            key={optValue}
                            label={opt.label}
                            checked={isChecked}
                            disabled={disabled}
                            __nextHasNoMarginBottom
                            onChange={(isCheckedNow) => {
                                const newValues = isCheckedNow
                                    ? [...selectedValues, opt.value]
                                    : selectedValues.filter((v) => v !== opt.value);
                                onChange(newValues);
                            }}
                        />
                    );
                })}
            </BaseControl>
        );
    }

    // Single checkbox mode
    return (
        <WPCheckboxControl
            label={label}
            help={help}
            checked={!!value}
            disabled={disabled}
            __nextHasNoMarginBottom
            onChange={onChange}
        />
    );
};

export default CheckboxControl;
